<se-buttons-toolbar [backVisible]="isBackVisible"
                    [buttonsData]="buttonsDataList$ | async"
                    [disableAll]="disableAll"
                    [leftSliderOptions]="leftSlider$ | async"
                    [rightSliderOptions]="rightSlider$ | async">
</se-buttons-toolbar>
